const layoutsWithNoTemplate = ['ONR'];

export default layoutsWithNoTemplate;
